module.exports = __webpack_public_path__ + "img/noauth.63e37ea4.png";